import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {Controller} from "react-hook-form";
import {MobileDatePicker} from "@mui/x-date-pickers/MobileDatePicker";
import {Button, TextField} from "@mui/material";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {getYYYYMMDD} from "../util/DateUtil";
import {grey} from '@mui/material/colors';

const CustomStDtSet = ({stName, edName, stLabel, edLabel, stControl, edControl, setValue, xs, sm, md, lg, xl, style}) => {

    const setLastWeek = () => {
        const todayDate = new Date();

        const today = getYYYYMMDD(todayDate);
        const lastWeekDate = new Date(todayDate);

        lastWeekDate.setDate(lastWeekDate.getDate() - 7);
        const lastWeek = getYYYYMMDD(lastWeekDate);

        setValue(stName, lastWeek);
        setValue(edName, today);
    }

    const setLastMonth = () => {
        const todayDate = new Date();
        const today = getYYYYMMDD(todayDate);
        const lastMonthDate = new Date(todayDate);
        lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
        const lastMonth = getYYYYMMDD(lastMonthDate);
        setValue(stName, lastMonth);
        setValue(edName, today);
    }

    const setLastYear = () => {
        const todayDate = new Date();
        const today = getYYYYMMDD(todayDate);
        const lastYearDate = new Date(todayDate);
        lastYearDate.setFullYear(lastYearDate.getFullYear() - 1);
        const lastYear = getYYYYMMDD(lastYearDate);
        setValue(stName, lastYear);
        setValue(edName, today);
    }

    const greyBtnColor = {
        height: 25,
        color: grey[700],
        backgroundColor: grey[300],
        "&:hover": {
            color: grey[50],
            backgroundColor: grey[600],
        },
    }

    return (
        <>
            <Grid container xs={xs ? xs : 12} sm={sm ? sm : 12} md={md ? md : 6} lg={lg ? lg : 3} xl={xl ? xl : 2}>
                <Grid xs={6} sm={6} md={6} lg={6} xl={6} sx={{ pl: 2, pt:2, pr:1, pb:0 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} sx={{width:'100%'}} adapterLocale="ko">
                        <Controller
                            name={stName}
                            control={stControl}
                            render={({ field: { onChange, value } }) => (
                                <MobileDatePicker
                                    label={stLabel}
                                    inputFormat="YYYY-MM-DD"
                                    value={value}
                                    onChange={(newValue) => onChange(newValue.format("YYYYMMDD"))}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                    sx={{width:'100%'}}
                                    views={['year', 'month', 'day']}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid xs={6} sm={6} md={6} lg={6} xl={6} sx={{ pl: 1, pt:2, pr:2, pb:0 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} sx={{width:'100%'}} adapterLocale="ko">
                        <Controller
                            name={edName}
                            control={edControl}
                            render={({ field: { onChange, value } }) => (
                                <MobileDatePicker
                                    label={edLabel}
                                    inputFormat="YYYY-MM-DD"
                                    value={value}
                                    onChange={(newValue) => onChange(newValue.format("YYYYMMDD"))}
                                    renderInput={(params) => <TextField fullWidth {...params} />}
                                    sx={{width:'100%'}}
                                    views={['year', 'month', 'day']}
                                />
                            )}
                        />
                    </LocalizationProvider>
                </Grid>

                <Grid container xs={12} sm={12} md={12} lg={12} xl={12} sx={{ pl:2, pr:2, pt:1 }}>
                    <Grid xs={4} sm={4} md={4} lg={4} xl={4} sx={{pl:2, pr:2}}>
                        <Button
                            fullWidth
                            sx={greyBtnColor}
                            onClick={setLastWeek}
                        >1주</Button>
                    </Grid>
                    <Grid xs={4} sm={4} md={4} lg={4} xl={4} sx={{pl:2, pr:2}}>
                        <Button
                            fullWidth
                            sx={greyBtnColor}
                            onClick={setLastMonth}
                        >1개월</Button>
                    </Grid>
                    <Grid xs={4} sm={4} md={4} lg={4} xl={4} sx={{pl:2, pr:2}}>
                        <Button
                            fullWidth
                            sx={greyBtnColor}
                            onClick={setLastYear}
                        >1년</Button>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default CustomStDtSet
